/**
 * DevExtreme (esm/ui/scroll_view/ui.scrollable.js)
 * Version: 24.1.8
 * Build date: Mon Dec 16 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import Scrollable from "../../__internal/ui/scroll_view/m_scrollable";
export default Scrollable;
